var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-0.6945739772105194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 94.076L103 0L0 94.076H31.2377V189H175.607V94.076H206Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206 94.076L103 0L0 94.076H31.2377V189H175.607V94.076H206Z",
    fill: "rgba(191, 191, 191, 100)",
    transform: "scale(1.4563106796116505, 1.5873015873015872)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206 94.076L103 0L0 94.076H31.2377V189H175.607V94.076H206Z",
    fill: "none",
    stroke: "#0c0c0c",
    strokeWidth: 0,
    clipPath: "url(#clip-0.6945739772105194)",
    transform: "scale(1.4563106796116505, 1.5873015873015872)",
    strokeDasharray: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32);
export default __webpack_public_path__ + "static/media/32.461f60023a11beb6f53a5fb3d5a6e1be.svg";
export { ForwardRef as ReactComponent };